import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
  selector: 'app-channel-training-participants-widget-demo',
  standalone: false,
  templateUrl: './channel-training-participants-widget-demo.component.html',
  styleUrl: './channel-training-participants-widget-demo.component.scss'
})
export class ChannelTrainingParticipantsWidgetDemoComponent {
  data: any[] = [
    { id: '1', channel: 'LinkedIn', participantsCount: 29 },
    { id: '2', channel: 'Mail newsletter', participantsCount: 54 }
  ];

  columns: TableColumn[] = [
    {
      dataField: 'channel',
      caption: this.translateService.instant('COMMON.FIELDS.CHANNEL'),
      disableFiltering: true
    },
     {
      dataField: 'participantsCount',
      caption: this.translateService.instant('CHANNEL-TRAINING-PARTICIPANTS.COUNT-OF-PARTICIPANTS-SHORT'),
      disableFiltering: true
    },
  ];

  constructor(private translateService: TranslateService){
  }
}
